import { theme } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectBookings } from 'reduxStore/bookings/selectors';
import { selectCategories } from 'reduxStore/categories/selectors';
import { selectLockersDevices } from 'reduxStore/devices/selectors';
import { selectPeople } from 'reduxStore/people/selectors';
import LockerDrawer from 'zComponents/molecules/LockerDrawer';
import { Button, Col, Empty, Flex, Row, Typography } from 'zui/Antd';

const { Text } = Typography;

function RenderLockersPanelContent({ searchResults = [], isSearching = false }) {
	//Hooks
	const {
		token: {
			colorTextLabel,
			fontWeightStrong,
			padding,
			colorPrimaryText,
			colorFill,
			paddingSM,
			borderRadius,
			lineHeight,
			lineHeightLG,
			fontSizeLG
		}
	} = theme.useToken();

	// Redux State
	const allLockerData = useSelector(selectLockersDevices);
	const bookingsData = useSelector(selectBookings);
	const peopleData = useSelector(selectPeople);
	const categories = useSelector(selectCategories);

	const [selectedDeviceID, setSelectedDeviceID] = useState(null);
	const [lockerDrawerVisible, setLockerDrawerVisible] = useState(false);

	const displayData = isSearching ? searchResults.map((result) => result.item) : allLockerData;

	const handleOpenModal = (deviceID) => {
		setSelectedDeviceID(deviceID);
		setLockerDrawerVisible(true);
	};

	if (displayData.length === 0) {
		return (
			<Flex align='center' justify='center' vertical style={{ width: '100%', padding }}>
				<Empty description={isSearching ? 'No search results found' : 'No devices to display'} />
			</Flex>
		);
	}

	return (
		<Row gutter={[20, 20]} justify='start'>
			{displayData.map((device, index) => {
				const deviceBooking = bookingsData?.find((booking) => booking.deviceID === device?.deviceID);
				const assignedPerson = deviceBooking?.assignedToPerson
					? peopleData?.find((person) => person.personID === deviceBooking.assignedToPerson)
					: null;
				const area = categories.find((category) => category.categoryID === device?.categoryID);

				return (
					<Col key={isSearching ? `search-${index}` : index} xl={8} lg={12} sm={24}>
						<Flex
							vertical
							style={{
								border: `1px solid ${colorFill}`,
								padding: paddingSM,
								borderRadius,
								boxSizing: 'border-box'
							}}
						>
							<Flex justify='space-between' align='center'>
								<Flex vertical gap={4} style={{ width: 0, flex: 1 }}>
									<Text
										ellipsis={{ tooltip: device?.name }}
										style={{
											width: '100%',
											color: colorTextLabel,
											fontWeight: fontWeightStrong,
											fontSize: fontSizeLG,
											lineHeight: lineHeightLG
										}}
									>
										{device?.name}
									</Text>
									<Text
										ellipsis={{ tooltip: `Area: ${area?.name || '--'}` }}
										style={{
											width: '100%',
											color: colorTextLabel,
											lineHeight: lineHeight
										}}
									>
										Area: {area?.name || '--'}
									</Text>
									<Text
										ellipsis={{ tooltip: `Booked: ${assignedPerson?.displayName || '--'}` }}
										style={{
											width: '100%',
											color: colorTextLabel,
											lineHeight: lineHeight
										}}
									>
										Booked: {assignedPerson?.displayName || '--'}
									</Text>
								</Flex>
								<Flex>
									<Button
										type='text'
										onClick={() => handleOpenModal(device?.deviceID)}
										style={{ color: colorPrimaryText }}
									>
										View Locker
									</Button>
								</Flex>
							</Flex>
						</Flex>
					</Col>
				);
			})}
			<LockerDrawer
				deviceID={selectedDeviceID}
				visible={lockerDrawerVisible}
				setVisible={setLockerDrawerVisible}
			/>
		</Row>
	);
}

export default RenderLockersPanelContent;
